import { z } from 'zod'

export const ActivityPaymentStatusDtoSchema = z.union([
  z.literal('paid'),
  z.literal('partially_paid'),
  z.literal('not_paid'),
  z.literal('pay_in_destination'),
])

export type ActivityPaymentStatusDto = z.infer<typeof ActivityPaymentStatusDtoSchema>
